import { useMemo } from 'react'
import { map } from 'ramda'

import {
  CompositeTableTemplate,
  renderCellGrayZeros,
} from 'app/common/templates-next/table-template'

import {
  ColumnKey,
  columnKeysLeft,
  columnKeysLeftHeaders,
  createCellProps,
  createHeaderCells,
  createHeaderCellsProps,
  createTotalCellProps,
} from './columnsByClasses'

import { OOPResultHeader } from './OOPResultHeader'
import { OrdersPurchases } from '../ordersPurchasesConvert'
import styles from './OOPByClasses.scss'

type Props = {
  data: OrdersPurchases
  loading?: boolean
  reportId: number
  reportFileName: string
}

export const OOPByClasses = ({ data, loading, reportId, reportFileName }: Props) => {
  const tableData = useMemo(() => {
    const {
      groups: { names, classes, countsByClass, totals },
      from,
      to,
    } = data
    const period =
      from && to
        ? `${from?.getStringFormatted('DD.MM.YYYY')} – ${to?.getStringFormatted('DD.MM.YYYY')}`
        : ''

    return {
      columnKeysLeft,
      columnKeysLeftHeaders,
      columnKeysMain: names,
      columnKeysMainHeaders: [names],
      header: createHeaderCells(names),
      headerProps: createHeaderCellsProps(names),
      data: map(
        (classTitle) => ({
          rowKey: classTitle,
          rowData: names.reduce(
            (acc, name, index) => {
              acc[name] = { columnKey: name, value: String(countsByClass[classTitle][index]) }
              return acc
            },
            {
              [ColumnKey.Class]: { columnKey: ColumnKey.Class as const, value: classTitle },
              [ColumnKey.Date]: { columnKey: ColumnKey.Date as const, value: period },
            },
          ),
        }),
        classes,
      ),
      dataProps: createCellProps(names),
      total: [
        {
          rowKey: 'total',
          rowData: names.reduce(
            (acc, name, index) => {
              acc[name] = { columnKey: name, value: String(totals[index]) }
              return acc
            },
            {
              [ColumnKey.Class]: { columnKey: ColumnKey.Class as const, value: '' },
              [ColumnKey.Date]: { columnKey: ColumnKey.Date as const, value: 'Итого' },
            },
          ),
        },
      ],
      totalProps: createTotalCellProps(names),
    }
  }, [data])

  return (
    <>
      <OOPResultHeader
        reportId={reportId}
        reportFileName={reportFileName}
        className={styles.header}
      />
      <CompositeTableTemplate
        data={tableData}
        loading={loading}
        emptyDataMessage="Нет записей, удовлетворяющих условиям"
        renderCell={renderCellGrayZeros}
        renderFooterCell={renderCellGrayZeros}
        disableTopSticky
      />
    </>
  )
}
